/* Source code provided by Full Rate (Steen Garbers Enevoldsen, Lasse Dalegaard) and subsuquently updated to ES6 */


function now() {
  return new Date().getTime()
}

function calc_req_size(dt: any, last_dt: any, size: any) {
  if (last_dt === 0) last_dt = dt
  return Math.ceil((size * Math.min(1.7 * last_dt, 400)) / dt)
}

// Returns a function that will cancel the session
function session(
  _id: any,
  target: any,
  onopen: any,
  onreceive: any,
  handler: any,
) {
  const sends: any[] = []
  let size = handler.minsize
  let exit = false
  let last_dt = 0

  function fire() {
    if (exit) return
    const msg = handler.req(size)
    sends.push([now(), size])
    ws.send(msg)
  }

  let ws: WebSocket
  try {
    ws = new WebSocket(target)
  } catch (e:any) {
    if (e.name === 'SecurityError') {
      onopen(undefined)
      return function () {
        return Promise.resolve()
      }
    } else {
      throw e
    }
  }
  ws.binaryType = 'blob'
  ws.onopen = function () {
    if (exit) return
    onopen(function () {
      fire()
      fire()
    })
  }
  ws.onclose = function (e) {
    if (exit) return
    exit = true
    if (!e.wasClean) onreceive(e.reason)
  }
  ws.onmessage = function (e) {
    if (exit) return
    const req = sends.shift()
    const v = handler.rep(e.data, req[1])
    if (v === false) {
      exit = true
      onreceive('Invalid data returned')
      return
    }
    onreceive(undefined, v)
    const dt = now() - req[0]
    size = calc_req_size(dt, last_dt, v)
    if (size > handler.maxsize) size = handler.maxsize
    last_dt = dt
    fire()
    if (dt < 20) setTimeout(fire, 100)
  }

  return function () {
    exit = true
    return new Promise<void>(function (resolve) {
      ws.onclose = function () {
        
        resolve()
      }
      ws.close()
    })
  }
}

function sessionDownload(id: any, target: any, onopen: any, onreceive: any) {
  return session(id, target, onopen, onreceive, {
    minsize: 10000,
    maxsize: 1000000,
    req: function req_download(size: any) {
      return 'DOWNLOAD ' + size
    },
    rep: function rep_download(data: any) {
      return data.size
    },
  })
}

const uploadbuf = (function () {
  const buf = new Uint8Array(1 * 1024 * 1024)
  for (let i = 0; i < buf.length; i++) {
    buf[i] = Math.floor(Math.random() * 256)
  }
  // Put the string 'UPLOAD ' at the front
  buf.set([85, 80, 76, 79, 65, 68, 32], 0)
  return buf
})()

function sessionUpload(id: any, target: any, onopen: any, onreceive: any) {
  return session(id, target, onopen, onreceive, {
    minsize: 10000,
    maxsize: 1000000,
    req: function req_upload(size: any) {
      return uploadbuf.slice(0, size)
    },
    rep: function rep_upload(data: any, reqsize: any) {
      return reqsize
    },
  })
}

function speedtest(opts: {
  target?: any
  progress_interval?: number
  concurrency?: number
  session?: any
  duration?: number
  smoothtime?: number
  onprogress?: (...args: any) => any
  onfinalize?: (...args: any) => any
}) {
  if (!opts.target) return Promise.reject('No target URL')
  if (Array.isArray(opts.target) && opts.target.length === 0)
    return Promise.reject('No targets given')
  if (!opts.session) return Promise.reject('No session')
  const duration = opts.duration || 10000
  const progressinterval = opts.progress_interval || 100
  const target_concurrency =
    Array.isArray(opts.target) && opts.target.length >= 10
      ? opts.target.length
      : undefined
  const concurrency = opts.concurrency || target_concurrency || 10
  let total = 0
  const samples = [[0, 0]]
  const smoothtime = opts.smoothtime || 3000

  let target_idx = 0
  function next_target() {
    if (Array.isArray(opts.target)) {
      return opts.target[target_idx++ % opts.target.length]
    }
    return opts.target
  }

  return new Promise(function (resolve, reject) {
    let begintime: any
    function stats() {
      const elapsed = now() - begintime
      while (samples.length > 0 && samples[0][0] < elapsed - smoothtime)
        samples.shift()
      samples.push([elapsed, total])
      const first = samples[0]
      const delta =
        samples.length <= 1
          ? 0
          : ((total - first[1]) / Math.min(smoothtime, elapsed - first[0])) *
            1000
      if (opts.onprogress) opts.onprogress(8 * delta, elapsed, total)
      return { speed: 8 * delta, elapsed: elapsed, total: total }
    }

    let timeout: any
    let interval: any
    function on_launch() {
      if (opts.onprogress) opts.onprogress(0, 0, 0)
      begintime = now()
      interval = setInterval(stats, progressinterval)
      timeout = setTimeout(function () {
        const ret = stats()
        cleanup().then(function () {
          resolve(ret)
        })
      }, duration)
    }

    const launches: any[] = []
    let failed = 0
    function onopen(launch: any) {
      if (launch === undefined) {
        failed++
        if (failed === concurrency)
          return cleanup().then(function () {
            reject('Ingen forbindelser kunne startes')
          })
      }
      launches.push(launch)
      if (launches.length === concurrency) {
        launches.map(function (l) {
          return l && l()
        })
        on_launch()
      }
    }

    function onreceive(err: any, amount: any) {
      if (err) {
        return cleanup().then(function () {
          reject(err)
        })
      }
      total += amount
    }

    const cancels: any[] = []
    for (let i = 0; i < concurrency; i++) {
      cancels.push(opts.session(i, next_target(), onopen, onreceive))
    }

    function cleanup() {
      if (opts.onfinalize) opts.onfinalize()
      clearInterval(interval)
      clearTimeout(timeout)
      return Promise.all(
        cancels.map(function (c) {
          return c()
        }),
      )
    }
  })
}

function latencytest(opts: { probes?: number; maxtime?: number; target: any }) {
  const probes = opts.probes || 20
  const maxtime = opts.maxtime || 2000
  if (!opts.target) return Promise.reject('No target URL')

  const ret: Promise<number[]> = new Promise(function (resolve, reject) {
    const inflight: number[] = []
    const results: number[] = []
    const ws = new WebSocket(opts.target)
    ws.binaryType = 'arraybuffer'

    function sendping() {
      const t = now()
      inflight.push(t)
      ws.send('PING ' + t)
    }

    setTimeout(function () {
      ws.close()
    }, maxtime)

    ws.onopen = function () {
      sendping()
    }
    ws.onclose = function (e) {
      if (!e.wasClean) return reject(e.reason)
      if (results.length !== 0) {
        resolve(results)
      } else {
        reject(
          'Ingen svar blev modtaget inden for ' +
            Math.ceil(maxtime / 1000) +
            ' sekunder',
        )
      }
    }
    ws.onmessage = function (e) {
      if (e.data.substr(0, 5) !== 'PONG ')
        return reject('Invalid response from server')
      let delta = now() - (inflight.shift()??now())
      if (delta <= 0) delta = 1
      results.push(delta)
      if (results.length < probes) {
        sendping()
      } else {
        ws.close()
      }
    }
  })
  return ret
}


// Testing if websockets endpoints are available
async function checkEndpoints(targets: Array<string>): Promise<any> {
  const availableTargets: Array<string> = []
  for (const endpoint of targets) {
    try {
      await testConnectionToEndpoint(endpoint)
      availableTargets.push(endpoint)
    } catch (err) {
      console.error(
        `Removing ${endpoint} endpoint from available targets - `,
        err,
      )
    }
  }
  return availableTargets
}

function testConnectionToEndpoint(endpoint: string) {
  const server = new WebSocket(endpoint)

  return new Promise<string>((resolve, reject) => {
    const timer = setTimeout(() => {
      clearTimeout(timer)
      reject('Connection timeout')
    }, 3000)
    server.onopen = () => resolve('Testing connection was successful')
    server.onerror = () => reject('Testing connection was unsuccessful')
  }).then(() => server.close())
}

export {
  speedtest,
  sessionUpload,
  sessionDownload,
  latencytest,
  checkEndpoints
}
